import z from 'zod'

// ============================================================================
// Role Schemas
// ============================================================================

export const ProviderUserRoleCodesSchema = z.union([
  z.literal('OWNER'),
  z.literal('ADMIN'),
  z.literal('FINANCE'),
  z.literal('GENERAL'),
  z.literal('READ-ONLY'),
])

export const ProviderUserRoleSchema = z.object({
  role_id: z.number(),
  role_name: z.string(),
  role_code: ProviderUserRoleCodesSchema,
  role_description: z.string(),
})

// ============================================================================
// Provider User Schemas
// ============================================================================

export const ProviderUserStatusSchema = z.union([
  z.literal('Active'),
  z.literal('Inactive'),
  z.literal('Pending'),
])

export const ProviderUserStatusCode = {
  PENDING: 0,
  ACTIVE: 1,
  INACTIVE: 2,
} as const

export const ProviderUserStatusCodeSchema = z.union([
  z.literal(ProviderUserStatusCode.PENDING),
  z.literal(ProviderUserStatusCode.ACTIVE),
  z.literal(ProviderUserStatusCode.INACTIVE),
])

export const ProviderUserSchema = z.object({
  id: z.number(),
  provider_id: z.number(),
  name: z.string().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  email: z.string().email(),
  last_login_at: z.string().nullable(),
  created_at: z.string(),
  status: ProviderUserStatusCodeSchema,
  status_name: ProviderUserStatusSchema,
  role: z.object({
    code: ProviderUserRoleCodesSchema,
    name: z.string(),
    id: z.number(),
  }),
})

// ============================================================================
// Type Exports
// ============================================================================

export type ProviderUserStatus = z.infer<typeof ProviderUserStatusSchema>
export type ProviderUserRoleCode = z.infer<typeof ProviderUserRoleCodesSchema>
export type ProviderUserRole = z.infer<typeof ProviderUserRoleSchema>
export type ProviderUser = z.infer<typeof ProviderUserSchema>
export type ProviderUserStatusCode = z.infer<
  typeof ProviderUserStatusCodeSchema
>
